import { render, staticRenderFns } from "./Donors.vue?vue&type=template&id=56e7e7c0&scoped=true&"
import script from "./Donors.vue?vue&type=script&lang=js&"
export * from "./Donors.vue?vue&type=script&lang=js&"
import style0 from "./Donors.vue?vue&type=style&index=0&id=56e7e7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7e7c0",
  null
  
)

export default component.exports